import React from 'react';
import { Grid2, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Button } from '@mui/material';
import { Select } from '@mui/material';
import TokenError from "../tokenError";
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';

const SuggestedRoutes = () => {
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('route_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const clientdataShown = localStorage.getItem('hideuserinfo');


    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    //sorting
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const fetchSuggestedRoutesData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/shuttle/fetch_suggested_routes';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp,
                city_id: cityFilter
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setRows(response.data);
                const sortedData = [...response.data].sort((a, b) => {
                    return b.route_id - a.route_id;
                });
                
                setRows(sortedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchSuggestedRoutesData();
    },[cityFilter])

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const exportCSV = () => {
        // Define which columns to include in the CSV
        const headers = [
            'Route ID',
            'User ID',
            'User Name',
            'Phone Number',
            'Pickup Address',
            'Drop Address',
            'Shift',
            'Description'
        ];

        // Map the data rows to match the headers
        const csvData = rows.map(row => {
            // Apply phone number masking based on clientdataShown
            const phoneNumber = clientdataShown == '0' ? row.phone_number : (() => {
                if (!row.phone_number) return '****';
                const phone = row.phone_number;
                // Remove any non-digit characters for processing
                const cleanPhone = phone.replace(/\D/g, '');
                if (cleanPhone.length <= 4) return '****';
                const firstTwo = cleanPhone.substring(0, 2);
                const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                return "+" + firstTwo + maskedMiddle + lastTwo;
            })();
            
            return [
                row.route_id,
                row.user_id,
                row.user_name,
                phoneNumber,
                row.pickup_address,
                row.drop_address,
                (row.shift == 1) ? "Morning": (row.shift == 2) ? "Evening" : (row.shift == 3) ? "Both" : "" ,
                row.description ? row.description : "--"
            ];
        });

        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        csvData.forEach(rowArray => {
            // Properly escape fields that might contain commas
            const formattedRow = rowArray.map(field => {
                // Convert to string and check if it needs quotes
                const stringField = String(field || '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    // Escape quotes and wrap in quotes
                    return `"${stringField.replace(/"/g, '""')}"`;  
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        // Create a blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', `suggested_routes.csv`);
        link.style.visibility = 'hidden';
        
        // Append to document, trigger download, and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Suggested Routes
            </Typography>

            {/* Filters */}
            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '1%', marginBottom: '2%' }}>
                <Select value={cityFilter} 
                onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                style={{width: '190px',height:'46px', marginTop:'0px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                    <MenuItem value="">Select City</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_name} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>

                <Grid2 item sx={{marginLeft:'1%', marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '46px',
                            width: '180px',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container" sx={{maxHeight:'72vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{minWidth:'120px'}}>
                                <TableSortLabel
                                    active={orderBy === 'route_id'}
                                    direction={orderBy === 'route_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('route_id')}
                                >
                                    Route ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{minWidth:'120px' }}>
                                <TableSortLabel
                                    active={orderBy === 'user_id'}
                                    direction={orderBy === 'user_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('user_id')}
                                >
                                    User ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{minWidth:'120px' }}>
                                <TableSortLabel
                                    active={orderBy === 'user_name'}
                                    direction={orderBy === 'user_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('user_name')}
                                >
                                    User Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{minWidth:'120px' }}>
                                <TableSortLabel
                                    active={orderBy === 'phone_number'}
                                    direction={orderBy === 'phone_number' ? order : 'asc'}
                                    onClick={() => handleRequestSort('phone_number')}
                                >
                                    Phone Number
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{minWidth:'180px'}}>
                                <TableSortLabel
                                    active={orderBy === 'pickup_address'}
                                    direction={orderBy === 'pickup_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_address')}
                                >
                                    Pickup Address
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ minWidth:'180px' }}>
                                <TableSortLabel
                                    active={orderBy === 'drop_address'}
                                    direction={orderBy === 'drop_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_address')}
                                >
                                    Drop Address
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Shift</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'description'}
                                    direction={orderBy === 'description' ? order : 'asc'}
                                    onClick={() => handleRequestSort('description')}
                                >
                                    Description
                                </TableSortLabel>
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                            return(
                                <TableRow key={row.route_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.route_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', fontWeight:'500' }}>{row.user_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                        {clientdataShown == '0' ? row.phone_number : (() => {
                                        if (!row.phone_number) return '****';
                                        const phone = row.phone_number;
                                        // Remove any non-digit characters for processing
                                        const cleanPhone = phone.replace(/\D/g, '');
                                        if (cleanPhone.length <= 4) return '****';
                                        const firstTwo = cleanPhone.substring(0, 2);
                                        const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                        const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                        return "+" + firstTwo + maskedMiddle + lastTwo;
                                    })()}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_address}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.drop_address}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{(row.shift == 1) ? "Morning": (row.shift == 2) ? "Evening" : (row.shift == 3) ? "Both" : "" }</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.description}</Typography></TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                {rows && (
                    <div className="custom-pagination">
                        <div className="pagination-info">
                            {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                            )} of ${rows.length} entries`}
                        </div>
                        <div className="pagination-controls">
                            <button
                                onClick={() => handleChangePage(null, page - 1)}
                                disabled={page === 0}
                                className="pagination-arrow"
                            >
                                <img src={prevIcon} alt="Previous" />
                            </button>
                            <div className="pagination-numbers">
                                {page > 1 && (
                                    <>
                                    <button
                                        onClick={() => handleChangePage(null, 0)}
                                        className="pagination-number"
                                    >
                                        1
                                    </button>
                                    <span className="pagination-dots">...</span>
                                    </>
                                )}
                                {[...Array(Math.ceil(rows.length / rowsPerPage))]
                                    .map((_, index) => index)
                                    .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                    .map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${
                                        page === index ? "active" : ""
                                        }`}
                                    >
                                        {index + 1}
                                    </button>
                                ))}

                                {page < Math.ceil(rows.length / rowsPerPage) - 2 && (
                                    <>
                                    <span className="pagination-dots">...</span>
                                    <button
                                        onClick={() =>
                                        handleChangePage(
                                            null,
                                            Math.ceil(rows.length / rowsPerPage) - 1
                                        )
                                        }
                                        className="pagination-number"
                                    >
                                        {Math.ceil(rows.length / rowsPerPage)}
                                    </button>
                                    </>
                                )}
                            </div>
                            <button
                                onClick={() => handleChangePage(null, page + 1)}
                                disabled={
                                    page >= Math.ceil(rows.length / rowsPerPage) - 1
                                }
                                className="pagination-arrow"
                            >
                                <img src={nextIcon} alt="Next" />
                            </button>
                        </div>
                    </div>
                )}
            </TableContainer>
        </div>
    );
};

export default SuggestedRoutes;
